import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=68cfb046"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=68cfb046&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cfb046')) {
      api.createRecord('68cfb046', component.options)
    } else {
      api.reload('68cfb046', component.options)
    }
    module.hot.accept("./Appointment.vue?vue&type=template&id=68cfb046", function () {
      api.rerender('68cfb046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/user/Appointment.vue"
export default component.exports